import LoginHeader from './LoginHeaderComponent';
import LocalLogin from './LocalLoginComponent';
import ExternalLogin from './ExternalLoginComponent';

import './LoginContainerComponent.css'


const LoginContainer = () => {
  return (
    <div className='login-box'>
      <LoginHeader/>
      <LocalLogin/>
      <ExternalLogin/>
    </div>
  );
}

export default LoginContainer;